/** Mapping of person type keys to their machine-readable values. */
export const PERSON_TYPES = {
    shelter: 'shelter',
    outreach: 'outreach',
    hotline: 'hotline',
    child: 'child',
};
/** Human-readable labels for each person type. */
export const PERSON_TYPE_LABELS = {
    shelter: 'Shelter Resident',
    outreach: 'Outreach Client',
    hotline: 'Hotline Caller',
    child: 'Child',
};
/** Short descriptions shown in the UI. */
export const PERSON_TYPE_DESCRIPTIONS = {
    shelter: 'Individuals residing in a shelter facility',
    outreach: 'Individuals receiving non-residential services',
    hotline: 'Individuals who contacted the crisis hotline',
    child: 'Children associated with an adult client',
};
/**
 * Defines which intake form steps apply to each person type.
 * Steps are identified by number (1-4) corresponding to
 * IntakeForm1Data through IntakeForm4Data.
 */
export const INTAKE_STEPS_BY_TYPE = {
    shelter: [1, 2, 3, 4],
    outreach: [1, 2, 4],
    hotline: [1, 2],
    child: [1], // Child uses ChildIntakeData instead
};
/**
 * Fields that are mandatory for each person type beyond the
 * base required set (firstName, lastName, intakeDate).
 */
export const REQUIRED_FIELDS_BY_TYPE = {
    shelter: ['gender', 'dateOfBirth'],
    outreach: ['gender'],
    hotline: [],
    child: ['parentPersonId', 'dateOfBirth'],
};
/**
 * Fields that are hidden for certain person types because
 * they do not apply (e.g. bedId is irrelevant for hotline).
 */
export const HIDDEN_FIELDS_BY_TYPE = {
    shelter: [],
    outreach: ['bedId', 'expectedDepartureDate', 'parentPersonId', 'schoolName', 'gradeLevel', 'pediatrician', 'custodyStatus'],
    hotline: ['bedId', 'expectedDepartureDate', 'parentPersonId', 'schoolName', 'gradeLevel', 'pediatrician', 'custodyStatus', 'ssn'],
    child: ['employmentStatus', 'monthlyIncome', 'educationLevel', 'isVeteran', 'isPregnant', 'bedId', 'expectedDepartureDate'],
};
/** All person type values as an array, useful for iteration. */
export const ALL_PERSON_TYPES = ['shelter', 'outreach', 'hotline', 'child'];
//# sourceMappingURL=person-types.js.map